import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your Firebase config
const firebaseConfig = {
    apiKey: "AIzaSyCIsM3xWu1ws1ijXvAqfeDFUbDl0dkDhy8",
    authDomain: "kolaydoy-e551a.firebaseapp.com",
    projectId: "kolaydoy-e551a",
    storageBucket: "kolaydoy-e551a.firebasestorage.app",
    messagingSenderId: "919044739997",
    appId: "1:919044739997:web:c74aa30bc2ae5371281574"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize messaging only if the environment supports service workers
let messaging;
if ('serviceWorker' in navigator) {
    try {
        messaging = getMessaging(app);

        // Listen for incoming messages safely
        const dispatchForegroundFcmPayload = (payload) => {
            if (!payload || typeof window === "undefined") {
                return;
            }
            window.dispatchEvent(
                new CustomEvent("fcm-foreground-message", { detail: payload })
            );
        };

        onMessage(messaging, (payload) => {
            console.log('📩 Firebase message received:', payload);
            dispatchForegroundFcmPayload(payload);
        });

        if (typeof navigator !== "undefined" && navigator.serviceWorker) {
            navigator.serviceWorker.addEventListener("message", (event) => {
                if (event.data?.type === "fcm-foreground-message") {
                    dispatchForegroundFcmPayload(event.data.payload);
                }
            });
        }
    } catch (err) {
        console.error('⚠️ Firebase Messaging initialization failed', err);
    }
} else {
    console.log('⚠️ Firebase Messaging not supported in this browser / WKWebView');
}

// Request user permission safely (ثبت SW قبل از getToken برای پایداری دیالوگ مجوز و توکن)
export const requestPermission = async () => {
    if (!messaging) {
        console.log('⚠️ Messaging not initialized. Cannot request permission.');
        return null;
    }

    try {
        const swUrl = `${process.env.PUBLIC_URL || ''}/firebase-messaging-sw.js`;
        const registration = await navigator.serviceWorker.register(swUrl);
        await navigator.serviceWorker.ready;

        const token = await getToken(messaging, {
            vapidKey: "BHcBl0eWcuydAezNbhB5NDuDufmjiTKsXwWlSJBZlEdltfxmHy7vClYVEmoRPfCt45egolfNwO_PzCYSrf1NvYc",
            serviceWorkerRegistration: registration,
        });
        return token;
    } catch (error) {
        console.error("Permission denied or failed to get token", error);
        return null;
    }
};

export { messaging };
